import inspect from 'object-inspect';
import { ExtendedLogger } from '../extended-logger';
import * as cache from './cache';
// need to extract out extended functions and inject logger.
// we don't really want to do console logs with loggly, as user
// won't see them ever (very unlikely). We do need to replicate functionality.
// So we need:
// 1. *bad* caching mechanism, all loggers call it
// 2. class that does actual logging, and extended logging?
// 3. export function that instantiates with name
const logger = (n) => new Logger(n);
class Logger {
    name;
    constructor(name) {
        this.name = name;
    }
    // Caching always saves all log levels
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    checkLevelEnabled(level) {
        return true;
    }
    now() {
        return new Date().toISOString();
    }
    buildMessage(level, ...args) {
        const extra = (args || []).map((e) => inspect(e)).join(' ');
        const logEntry = `${this.now()} ${this.name} [${level}] ${extra}`;
        return logEntry;
    }
    trace(...args) {
        void cache.push(this.buildMessage('TRACE', ...args));
    }
    debug(...args) {
        void cache.push(this.buildMessage('DEBUG', ...args));
    }
    info(...args) {
        void cache.push(this.buildMessage('INFO', args));
    }
    warn(...args) {
        void cache.push(this.buildMessage('WARN', args));
    }
    error(...args) {
        void cache.push(this.buildMessage('ERROR', args));
    }
}
export function CachedLogger(name) {
    const log = new ExtendedLogger(logger, name);
    return log;
}
//# sourceMappingURL=logger.js.map